import React from "react";
import { Box, Stack, Button } from "digiwash-components";

function TabBar(props) {
  return (
    <Box>
      <Box br="l" style={{ overflow: "hidden" }}>
        <Stack br="l" bg="neutrals.200" style={{ width: "100%" }}>
          {props.data?.map((item, index) => {
            return (
              <Box style={{ flexGrow: 1 }}>
                <Button
                  textColor={
                    props.selected === index ? "common.white" : "common.black"
                  }
                  fill={props.selected === index ? "primary" : "transparent"}
                  onPress={() => {
                    props.onSelect(index);
                  }}
                >
                  {item.display_name ? item.display_name : item.name}
                </Button>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
}
export default TabBar;
